import type { Async } from '@client/new/helpers/types';

import {
  BundleOption,
  useAutomationBundlesModel,
} from '../model/AutomationBundles.model';
import { AutomationDetailsViewModel } from './AutomationDetails.viewModel';

export type OtpPitchTargetConfigViewModel = {
  options: Async<
    BundleOption[],
    { message: string; retry: () => Promise<void> }
  >;
  /** The picker only matters with more than one candidate, or when the
   *  server already asked for one. One candidate is picked server-side. */
  showPicker: boolean;
  singleBundleNote: string | null;
  selectedBundleId: string | null;
  selectBundle: (bundleId: string | null) => void;
  includePushes: boolean;
  setIncludePushes: (includePushes: boolean) => void;
  validation?: string;
};

export const useOtpPitchTargetConfigViewModel = (
  creatorId: number,
  details: AutomationDetailsViewModel,
): OtpPitchTargetConfigViewModel => {
  const options = useAutomationBundlesModel(creatorId);
  const bundles = options.type === 'fetched' ? options.value : [];
  const showPicker =
    options.type !== 'fetched' ||
    bundles.length > 1 ||
    details.readinessReason !== null ||
    details.draft.config.otpPitchTargetProductId !== '';

  return {
    options,
    showPicker,
    singleBundleNote:
      !showPicker && bundles.length === 1
        ? `Your subscription ${bundles[0].title} is the only one, so every message points at it.`
        : null,
    selectedBundleId: details.draft.config.otpPitchTargetProductId || null,
    selectBundle: (bundleId) =>
      details.setConfig({ otpPitchTargetProductId: bundleId ?? '' }),
    includePushes: details.draft.includePushes,
    setIncludePushes: details.setIncludePushes,
    validation: details.validation.otpPitchTargetProductId,
  };
};
